// Frontend: PostForm.jsx (For clients to create posts)
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import ServiceProvider from '../ServiceProvider';

const PostForm = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    type: 'contract',
    roleNeeded: 'contractor',
    budget: '',
    location: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitPost = async () => {
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}oosh/service/post`, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      toast.success('Post created successfully');
    } catch (err) {
      console.log(err)
      toast.error('Failed to create post');
    }
    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-blue-600">Post a Job</h2>
      <div className="grid grid-cols-1 gap-4">
        <input
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="Title"
          className="p-2 border rounded-md"
          required
        />
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Description"
          className="p-2 border rounded-md"
          rows="4"
          required
        />
        <select name="type" value={formData.type} onChange={handleChange} className="p-2 border rounded-md">
          <option value="contract">Contract</option>
          <option value="service">Service Needed</option>
          <option value="supply">Goods Supply</option>
        </select>
        <select name="roleNeeded" value={formData.roleNeeded} onChange={handleChange} className="p-2 border rounded-md">
          <option value="contractor">Contractor</option>
          <option value="serviceprovider">Service Provider</option>
          <option value="supplier">Supplier</option>
        </select>
        <input
          name="budget"
          type="number"
          value={formData.budget}
          onChange={handleChange}
          placeholder="Budget"
          className="p-2 border rounded-md"
        />
        <input
          name="location"
          value={formData.location}
          onChange={handleChange}
          placeholder="Location"
          className="p-2 border rounded-md"
        />
      </div>
      <button
        onClick={submitPost}
        disabled={loading}
        className="mt-4 bg-green-500 text-white p-2 rounded-md hover:bg-green-600 disabled:opacity-50"
      >
        {loading ? 'Posting...' : 'Post Job'}
      </button>
      <ServiceProvider />
    </div>
  );
};

export default PostForm;